<template>
	<n-popselect v-model:value="currentLocale" :options="list" :render-label>
		<div class="bg-body flex size-4 min-w-4 items-center justify-center rounded-full">
			<Icon :size="16" :name="`circle-flags:${currentLocale.toLowerCase()}`" />
		</div>
	</n-popselect>
</template>

<script lang="ts" setup>
// TODO-NEXT: se l'utente è loggato, fare una chiamata api ad ogni cambio lingua per aggiornare la lingua dell'utente sul db
import type { SelectOption } from "naive-ui"
import type { VNodeChild } from "vue"
import { NPopselect } from "naive-ui"
import { computed, h } from "vue"
import { useI18n } from "vue-i18n"
import Icon from "@/components/common/Icon.vue"
import { useLocalesStore } from "@/stores/i18n"

const localesStore = useLocalesStore()
const { setLocale } = localesStore
const { t } = useI18n()

const list = computed(() =>
	localesStore.availableLocales.map(i => ({
		label: i,
		value: i
	}))
)

const currentLocale = computed({
	get: () => localesStore.locale,
	set: v => setLocale(v)
})

function renderLabel(option: SelectOption): VNodeChild {
	return [
		h(Icon, {
			color: "#000",
			style: {
				verticalAlign: "-0.15em",
				marginRight: "8px"
			},
			name: `circle-flags:${option.label}`
		}),
		h(
			"span",
			{},
			{
				default: () => t(`common.locales.${option.label}`, `${option.label}`)
			}
		)
	]
}
</script>
